import { flowsApi } from 'apis/flows';
import { useFeatureFlag } from 'utils/featureFlagging/useFeatureFlag';
import { useCurrentUser } from 'utils/user';
/**
 * A hook that checks whether the business hours feature in Analytics should be
 * enabled, based on feature flag state, user role and whether the organization
 * has at least one business hours schedule created.
 */
export const useHasAnalyticsBusinessHours = () => {
    const flags = useFeatureFlag(['analytics-business-hours']);
    const { currentRole: { atLeastSystemadmin }, } = useCurrentUser();
    const hasFlagAndAccessRole = flags.analyticsBusinessHours && atLeastSystemadmin;
    const { data } = flowsApi.useReadFlowsSchedulesQuery({ limit: 1 }, {
        skip: !hasFlagAndAccessRole,
    });
    const hasBusinessHours = hasFlagAndAccessRole && !!(data === null || data === void 0 ? void 0 : data.data.total_number_of_schedules);
    return hasBusinessHours;
};
